const API_KEY = "KX427EDYSVSZSU7WQ66APJ4KC";

export async function searchWeather(location, unit) {
  try {
    const weatherData = await getData(location, unit);
    return curateData(weatherData);
  } catch (error) {
    console.log(error);
    return { errorMsg: "No location found." };
  }
}

async function getData(location, unit) {
  const response = await fetch(
    `https://weather.visualcrossing.com/VisualCrossingWebServices/rest/services/timeline/${location}?key=${API_KEY}&unitGroup=${unit}`,
  );
  if (response.status !== 200) throw new Error(response.status);
  const responseJson = await response.json();
  return responseJson;
}

function curateData(json) {
  const currentConditions = Object.assign(
    {},
    {
      location:
        json.resolvedAddress.charAt(0).toUpperCase() +
        json.resolvedAddress.slice(1),
      currentCondition: json.currentConditions.conditions,
      conditionKeyword: json.currentConditions.icon,
      currentTemp: Math.round(json.currentConditions.temp),
      currentTempMin: Math.round(json.days[0].tempmin),
      currentTempMax: Math.round(json.days[0].tempmax),
    },
  );
  return currentConditions;
}
